import { Col, DropdownBox, Label, Row } from "client/CommonComponents";
import { DateRangePicker } from "rsuite";
import moment from "moment";
import './CreateNewAudit.scss'



const CreateNewAudit = (props:any) => {
    const {onChangeAuditYear, yearsDropDown, onDateChange, auditDetails, maxDateRange, minDateRange, error, isEditClick, isNotEditable, disableAuditYear} = props
    const {allowedRange} = DateRangePicker
    return(
        <Row className="add-user-block">
            <Col xs={12} sm={12} md={6} lg={6} xl={6} className='mb-3'>
                <Label required data-attribute="CreateNewAudit_Default_Label">Year</Label>
               <DropdownBox
                    className={error?.year ? 'controlValidation' : ''}
                    placeholder="Select"
                    onChange={onChangeAuditYear}
                    options={isEditClick ? [{
                        key: auditDetails?.fy,
                        text: auditDetails?.fy,
                        value: auditDetails?.fy
                    }] : yearsDropDown}
                    disabled={isEditClick}
                    selectedKey={auditDetails?.fy}
                 data-attribute="CreateNewAudit_Default_Dropdown" />
                {error?.year && (
                    <span className="validMessage">
                        {error?.year}
                    </span>
          )}
            </Col>  
            <Col xs={12} sm={12} md={6} lg={6} xl={6} className='mb-3'>
                <Label required data-attribute="CreateNewAudit_Default_Label_2">Audit Start & End Date</Label>
                <DateRangePicker
                    placement='bottomEnd'
                    format="MM-dd-yyyy"
                    character=' - '
                    onChange={(e?: any) => {onDateChange(e, "auditDate")}}
                    placeholder='MM-DD-YYYY - MM-DD-YYYY'
                    preventOverflow={true} 
                    className={`form-control date-range-picker ${error?.AuditDateRange ? 'controlValidation' : ''}`}
                    value={auditDetails?.dateRange}
                    defaultCalendarValue={minDateRange ? [new Date(minDateRange), new Date(minDateRange)] : [new Date(moment().subtract(1, 'months').startOf('month').toDate()), new Date(moment().endOf('month').toDate())]}
                    disabledDate={allowedRange?.(minDateRange, maxDateRange)}
                    disabled={isNotEditable || disableAuditYear}
                 data-attribute="CreateNewAudit_Default_DateRangePicker" />
                {error?.AuditDateRange && (
                    <span className="validMessage">
                        {error?.AuditDateRange}
                    </span>
                )}
            </Col> 
            <Col xs={12} sm={12} md={6} lg={6} xl={6} className='mb-3'>
                <Label required data-attribute="CreateNewAudit_Default_Label_3">Audit Readiness Start & End Date</Label>
                <DateRangePicker
                    placement='bottomEnd'
                    format="MM-dd-yyyy"
                    character=' - '
                    onChange={(e?: any) => {onDateChange(e, "auditReadinessDate")}}
                    placeholder='MM-DD-YYYY - MM-DD-YYYY'
                    preventOverflow={true} 
                    className={`form-control date-range-picker ${error?.auditReadinessDateRange ? 'controlValidation' : ''}`}
                    value={auditDetails?.auditReadinessDateRange}
                    disabled={isNotEditable}
                 data-attribute="CreateNewAudit_Default_DateRangePicker_2" />
                {error?.auditReadinessDateRange && (
                    <span className="validMessage">
                        {error?.auditReadinessDateRange}
                    </span>
                )}
            </Col>
            <Col xs={12} sm={12} md={6} lg={6} xl={6} className='mb-3'>
                <Label required data-attribute="CreateNewAudit_Default_Label_4">Audit Training Start & End Date</Label>
                <DateRangePicker
                    placement='bottomEnd'
                    format="MM-dd-yyyy"
                    character=' - '
                    onChange={(e?: any) => {onDateChange(e, "auditTrainingDate")}}
                    placeholder='MM-DD-YYYY - MM-DD-YYYY'
                    preventOverflow={true} 
                    className={`form-control date-range-picker ${error?.auditTrainingDateRange ? 'controlValidation' : ''}`}
                    value={auditDetails?.auditTrainingDateRange}
                    disabled={isNotEditable}
                 data-attribute="CreateNewAudit_Default_DateRangePicker_3" />
                {error?.auditTrainingDateRange && (
                    <span className="validMessage">
                        {error?.auditTrainingDateRange}
                    </span>
                )}
            </Col>        
        </Row>
    )
}

export default CreateNewAudit;